// eslint-disable-next-line no-unused-vars
const logError = (e) => {
  // TODO log error in monorepo sentry
  // console.error(e);
};

const appendScriptToBody = ({ script, name }) => {
  if (document.querySelector('body')) {
    document.querySelector('body').appendChild(script);
  } else {
    const e = new Error(`Failed to inject ${name} script`);
    logError(e);
  }
};

// this injects window.google and not the legacy window.gapi JS api
export const injectGoogleScript = (callback) => {
  if (!window.google) {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.onload = callback;
    script.id = 'google-client-script';
    appendScriptToBody({ script, name: 'google gsi' });
  }
};

export const injectAppleScript = () => {
  if (!window.apple) {
    const script = window.document.createElement('script');
    script.src =
      'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
    script.async = true;
    appendScriptToBody({ script, name: 'apple' });
  }
};

export default { injectGoogleScript, injectAppleScript };
